import type { AgentProgressStep } from "../api/storeChatSessionsStreamApi";

export const getActiveProgressTool = (
  progressSteps: AgentProgressStep[],
): string | null => {
  const startedTools = progressSteps.filter((step) => step.phase === "started");
  for (let index = startedTools.length - 1; index >= 0; index -= 1) {
    const startedStep = startedTools[index];
    if (startedStep === undefined) {
      continue;
    }
    const startedIndex = progressSteps.indexOf(startedStep);
    if (startedIndex === -1) {
      continue;
    }
    const isDone = progressSteps
      .slice(startedIndex + 1)
      .some((step) => step.tool === startedStep.tool && step.phase === "done");
    if (!isDone) {
      return startedStep.tool;
    }
  }
  return null;
};

export const getAgentProgressLabelKey = (tool: string): string =>
  `storeChatSessions.agentProgress.${tool}`;
